import { IPostUserBody } from '@types';
import { AxiosError, AxiosResponse } from 'axios';
import { FetchResult, instance } from './config';
import { useMutation } from '@tanstack/react-query';

// 어드민 - 회원 생성
async function postUser(variables: { body: IPostUserBody }): Promise<AxiosResponse<FetchResult<string>>> {
  const response = await instance.post(`/users`, variables.body);
  return response;
}

const usePostUser = (
  onSuccess?: (data: AxiosResponse<FetchResult<string>>) => void,
  onError?: (err: AxiosError) => void
) => {
  const { mutateAsync, isPending } = useMutation({
    mutationKey: ['post', `/users`],
    mutationFn: (variables: { body: IPostUserBody }) => postUser(variables),
    onSuccess: (data) => {
      onSuccess?.(data);
    },
    onError: (err: AxiosError) => {
      onError?.(err);
    },
    retry: false
  });

  return { mutateAsync, isPending };
};

export default usePostUser;
